import React, { Component } from 'react';
import CodeHighlight from 'code-highlight';

export default class extends Component {
  shouldComponentUpdate() {
    return false;
  }
  render() {
    return  <CodeHighlight language="html">{this.props.ampHtml}</CodeHighlight>
  }
}



// WEBPACK FOOTER //
// ./src/components/result/wrapperCode.js